exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".unit-settings table[data-v-643c517d]{border:2px solid #000;border-collapse:collapse}.unit-settings table th[data-v-643c517d],.unit-settings table td[data-v-643c517d]{border-bottom:1px solid #000;padding:5px 10px}", ""]);

